import { TreeNode } from '../../basetree/BaseTree.vue.d';

/**
 * Covert deeply nested tree node into one level array.
 */
const flattenTreeNodeChildren = (nodes: TreeNode[] | undefined): TreeNode[] => {
  if (!nodes) return [];

  return nodes.flatMap((node) => [
    { ...node },
    ...flattenTreeNodeChildren(node.children),
  ]);
};

export default flattenTreeNodeChildren;
